import { render, staticRenderFns } from "./ProfileCourses.vue?vue&type=template&id=1082adcc&"
import script from "./ProfileCourses.vue?vue&type=script&lang=js&"
export * from "./ProfileCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports